import type { FC } from "react";

import { SearchDefaultIcon } from "@jti/brand-icons/search-default";
import { Button } from "@jti/core-components/components/Button";

import styles from "./SearchFormSubmitButton.module.scss";

type SearchFormSubmitButtonProps = {
  isPending: boolean;
  disabled: boolean;
  label: string;
  isMobile?: boolean;
};

export const SearchFormSubmitButton: FC<SearchFormSubmitButtonProps> = ({
  isPending,
  disabled,
  label,
  isMobile = false,
}) => (
  <Button
    variant="primary"
    type="submit"
    pending={isPending}
    className={styles.button}
    data-testid="searchSubmit"
    disabled={disabled}
    aria-label={label}
    size={isMobile ? "sm" : "md"}
    iconBefore={SearchDefaultIcon}
  />
);
